/*
 * @Author: Zhouqi
 * @Date: 2025-12-22 14:23:18
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:24:20
 */
/*
 * @Author: Zhouqi
 * @Date: 2025-12-19 18:19:55
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:23:18
 */
const InputErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.701 2.25C7.278 1.25 8.721 1.25 9.299 2.25L14.495 11.25C14.6267 11.478 14.696 11.7367 14.696 12C14.696 12.2633 14.6267 12.522 14.495 12.75C14.3634 12.978 14.174 13.1674 13.946 13.299C13.718 13.4307 13.4593 13.5 13.196 13.5H2.804C2.54061 13.5002 2.28183 13.431 2.05366 13.2994C1.8255 13.1678 1.63601 12.9785 1.50424 12.7504C1.37248 12.5224 1.30308 12.2636 1.30304 12.0002C1.303 11.7369 1.37231 11.4781 1.504 11.25L6.701 2.25ZM8 4C8.19891 4 8.38968 4.07902 8.53033 4.21967C8.67098 4.36032 8.75 4.55109 8.75 4.75V7.75C8.75 7.94891 8.67098 8.13968 8.53033 8.28033C8.38968 8.42098 8.19891 8.5 8 8.5C7.80109 8.5 7.61032 8.42098 7.46967 8.28033C7.32902 8.13968 7.25 7.94891 7.25 7.75V4.75C7.25 4.55109 7.32902 4.36032 7.46967 4.21967C7.61032 4.07902 7.80109 4 8 4ZM8 12C8.26522 12 8.51957 11.8946 8.70711 11.7071C8.89464 11.5196 9 11.2652 9 11C9 10.7348 8.89464 10.4804 8.70711 10.2929C8.51957 10.1054 8.26522 10 8 10C7.73479 10 7.48043 10.1054 7.29289 10.2929C7.10536 10.4804 7 10.7348 7 11C7 11.2652 7.10536 11.5196 7.29289 11.7071C7.48043 11.8946 7.73479 12 8 12Z"
        fill="#DE014A"
      />
    </svg>
  );
};
export default InputErrorIcon;
